import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { ExplorerEmptyStateProps } from '../Components/ExplorerEmpyState';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { RecommendationType, RecommendationTypeDropdown } from './RecommendationTypeDropdown';

export interface RecommendationsSpaceStateProps {
  readonly urls: SpacesSiteUrls;
  readonly recommendationType: RecommendationType;
}

export interface RecommendationSpaceDispatchProps {
  readonly recommendationTypeSelected: (value: RecommendationType) => void;
}

export type RecommendationsSpaceProps = RecommendationsSpaceStateProps & RecommendationSpaceDispatchProps;

export class RecommendationsSpace extends React.PureComponent<RecommendationsSpaceProps & ReactDirectiveProps> {
  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <div className={ SpaceContainerStyles.MastheadArea }>
          <div className={ExplorerStyles.SpaceHeaderContent}>
            <div className={ExplorerStyles.SpaceHeaderText}>{Messages.vizRecommendationsTitle()}</div>
          </div>
        </div>
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            angularContext={this.props.angularContext}
            supportedDisplayModes={['thumbnail']}
            emptyStateProps={this.emptyStateProps()}
            toolbarProps= {{
              supportFilterPanel: false,
              hideSelection: true,
              toolbarVisibility: 'enabled',
              toolbarContentFilterControl: this.recommendationTypeFilterControl(),
            }}
          />
        </div>
      </div>
    );
  }

  private recommendationTypeFilterControl(): JSX.Element {
    return (
      <React.Fragment>
        <span className={ExplorerStyles.ToolbarDropdownLabel}> {Messages.filterByTypeDropdown_label_for_recommendation()} </span>
          {
            <RecommendationTypeDropdown
              disabled={false}
              recommendationTypeSelected={this.props.recommendationTypeSelected}
              recommendationType={this.props.recommendationType} />
            }
      </React.Fragment>
    );
  }

  private emptyStateProps(): ExplorerEmptyStateProps {
    return {
      iconUrl: imgPath('spaces_empty_recommendation.svg'),
      primaryMessage: Messages.vizRecommendationsEmptyStatePrimary(),
      secondaryMessage: Messages.vizRecommendationsEmptyStateSecondary()
    };
  }
}
